// extracted by mini-css-extract-plugin
export default {"form":"MzkavKWj","button":"DySOyNgW","field":"dX6SfWfG","timer":"TQQ3nHQh","icon":"BWeaBapN","error":"qyb3wsu5"};